export const APP_KEY = process.env.REACT_APP_KEY;

export const TEST_USER = {
  EMAIL: process.env.REACT_APP_TEST_USER_EMAIL || '',
  PASSWORD: process.env.REACT_APP_TEST_USER_PASSWORD || '',
};

export const STYLES = {
  MONEY: {
    DEFAULT: {
      color: 'black',
    },
    POSITIVE: {
      color: 'blue',
    },
    NEGATIVE: {
      color: 'red',
    },
    NEUTRAL: {
      color: 'orange',
    },
  },
};

const MAIN_TITLE = 'Banco Mais';

export const ORDER_BY = {
  user_school_name: ['user', 'classe', 0, 'serie', 'school', 'name'],
  user_serie_name: ['user', 'classe', 0, 'name'],
  user_classe_name: ['classe', 0, 'name'],
  user_name: ['user', 'name'],
  user_placa: ['user', 'placa'],
  school_name: ['classe', 0, 'serie', 'school', 'name'],
  serie_name: ['classe', 0, 'name'],
  classe_name: ['classe', 0, 'name'],
  name: ['name'],
  id: ['id'],
  saldo: ['saldo'],
  ativo: ['ativo']
};

export const API_CONF = {
  BASE_URL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_VERSION}`,
  PREFIX: `${process.env.REACT_APP_API_PREFIX}`,
  TIMEOUT: 30000,
};

export const PAGINATION = {
  PER_PAGE: 15,
};

export const API_ROUTES = {
  ACCOUNTS: `${API_CONF.PREFIX}/accounts`,
  AUTH: `${API_CONF.PREFIX}/auth`,
  BALANCE: `${API_CONF.PREFIX}/balance`,
  BANKS: `${API_CONF.PREFIX}/banks`,
  CLASSES: `${API_CONF.PREFIX}/classes`,
  DEPOSITOLOGS: `${API_CONF.PREFIX}/depositologs`, // TODO rename LOGDEPOSITOS
  DEPOSITOS_LOTE: `${API_CONF.PREFIX}/depositos-lote`,
  DEPOSITOS: `${API_CONF.PREFIX}/depositos`,
  LOGOUT: `${API_CONF.PREFIX}/logout`,
  PROFILES: `${API_CONF.PREFIX}/profiles`,
  REFRESH: `${API_CONF.PREFIX}/refresh`,
  SAQUES_LOTE: `${API_CONF.PREFIX}/saques-lote`,
  SAQUES: `${API_CONF.PREFIX}/saquelogs`, // TODO rename SAQUELOGS
  SCHOOLS: `${API_CONF.PREFIX}/schools`,
  SERIES: `${API_CONF.PREFIX}/series`,
  TRANSFERENCIAS: `${API_CONF.PREFIX}/transferencialogs`, // TODO rename TRANSFERENCIALOGS
  LIST: `${API_CONF.PREFIX}/list`,
  USERS: `${API_CONF.PREFIX}/users`,
  HIDE: `${API_CONF.PREFIX}/hide`,
  COMPARAR: `${API_CONF.PREFIX}/comparar`,
};

export const PAGE_MENU = {
  ABOUT: `Sobre`,
  CLASSES: `Classes`,
  CLI_ACCOUNT: `Minha conta`,
  CLI_HISTORY: `Histórico`,
  CLIENT: `Clientes`,
  CONTACT: `Contato`,
  DASHBOARD: `Dashboard`,
  DEPOSITO: `Depósitos`,
  DEPOSITOLOGS: `Depósitos`,
  DEPOSITOS: `Depósitos`,
  EXIT: `Sair`,
  HOME: `Home`,
  LOGIN: `Login`,
  LOGS: `Logs`,
  OPERATIONS: `Operações`,
  ROOT: `${MAIN_TITLE}`,
  SAQUES: `Saques`,
  SCHOOLS: `Agências`,
  SERIES: `Séries`,
  SIGNIN: `Entrar`,
  SIGNOUT: `Sair`,
  TEST: `Teste`,
  TEST2: `Teste 2`,
  TRANSFERENCIAS: `Transferencias`,
  USERS: `Clientes`,
  VALIDACOES: `Validações`,
};

export const PAGE_ROUTE = {
  ABOUT: `/about`,
  CLASSES_STORE: `/classes/store`,
  CLASSES_UPDATE: `/classes/update`,
  CLASSES: `/classes`,
  CLIENT: `/client`,
  CONTACT: `/contact`,
  DASHBOARD: `/dashboard`,
  DEPOSITO: `/depositos`,
  DEPOSITOLOGS: `/depositolog`,
  HOME: `/home`,
  LOGIN: `/login`,
  LOGS: `/logs`,
  OPERATIONS: `/operations`,
  ROOT: `/`,
  SAQUES: `/saques`,
  SCHOOLS: `/schools`,
  SERIES_STORE: `/series/store`,
  SERIES_UPDATE: `/series/update`,
  SERIES: `/series`,
  SIGNIN: `/signin`,
  SIGNOUT: `/signout`,
  TEST: `/test`,
  TEST2: `/test2`,
  TRANSFERENCIAS: `/transferencias`,
  USERS_STORE: `/users/store`,
  USERS_UPDATE: `/users/update`,
  USERS: `/users`,
  VALIDACOES: `/validacoes`,
};

export const PAGE_TITLE = {
  ABOUT: `${MAIN_TITLE} - ${PAGE_MENU.ABOUT}`,
  CLASSES: `${MAIN_TITLE} - ${PAGE_MENU.CLASSES}`,
  CONTACT: `${MAIN_TITLE} - ${PAGE_MENU.CONTACT}`,
  DASHBOARD: `${MAIN_TITLE} - ${PAGE_MENU.DASHBOARD}`,
  DEPOSITO: `${MAIN_TITLE} - ${PAGE_MENU.DEPOSITO}`,
  DEPOSITOLOGS: `${MAIN_TITLE} - ${PAGE_MENU.DEPOSITOLOGS}`,
  DEPOSITOS: `${MAIN_TITLE} - ${PAGE_MENU.DEPOSITOS}`,
  HOME: `${MAIN_TITLE} - ${PAGE_MENU.HOME}`,
  LOGIN: `${MAIN_TITLE} - ${PAGE_MENU.LOGIN}`,
  LOGS: `${MAIN_TITLE} - ${PAGE_MENU.LOGS}`,
  OPERATIONS: `${MAIN_TITLE} - ${PAGE_MENU.OPERATIONS}`,
  ROOT: `${MAIN_TITLE} - ${PAGE_MENU.ROOT}`,
  SAQUES: `${MAIN_TITLE} - ${PAGE_MENU.SAQUES}`,
  SCHOOLS: `${MAIN_TITLE} - ${PAGE_MENU.SCHOOLS}`,
  SERIES_STORE: `${MAIN_TITLE} - Adicionar ${PAGE_MENU.SERIES}`,
  SERIES: `${MAIN_TITLE} - ${PAGE_MENU.SERIES}`,
  SIGNIN: `${MAIN_TITLE} - ${PAGE_MENU.SIGNIN}`,
  SIGNOUT: `${MAIN_TITLE} - ${PAGE_MENU.SIGNOUT}`,
  TEST: `${MAIN_TITLE} - ${PAGE_MENU.TEST}`,
  TEST2: `${MAIN_TITLE} - ${PAGE_MENU.TEST2}`,
  TRANSFERENCIAS: `${MAIN_TITLE} - ${PAGE_MENU.TRANSFERENCIAS}`,
  USERS_STORE: `${MAIN_TITLE} - Adicionar ${PAGE_MENU.USERS}`,
  USERS_UPDATE: `${MAIN_TITLE} - Atualizar ${PAGE_MENU.USERS}`,
  USERS: `${MAIN_TITLE} - ${PAGE_MENU.USERS}`,
  VALIDACOES: `${MAIN_TITLE} - ${PAGE_MENU.VALIDACOES}`,
};

export const PAGE_COPYRIGHT = {
  DEVELOPMENT_BY: 'Copyright © desenvolvido por',
  LINK_TEXT: 'Capital Social',
  LINK: 'https://capsocial.ong.br/',
  LOGO_ALT: ' ',
  LOGO: `${process.env.PUBLIC_URL}/assets/logos/Logo-AMPJyjl1WlFlpG9V-w800.png`,
};

export const ABOUT = {
  DOCUMENT_TITLE: 'Banco Mais - Sobre',
  LABEL_TITLE_TEXT: 'Sobre',
};

export const LOGIN = {
  DOCUMENT_TITLE: 'Banco Mais - Login',
  LABEL_LOGIN_HINT: 'Digite seu login de acesso',
  LABEL_LOGIN_TEXT: 'Login',
  LABEL_PASSWORD_HINT: 'Digite sua senha',
  LABEL_PASSWORD_TEXT: 'Senha',
  LABEL_SUBMIT_TEXT: 'Acessar',
  LABEL_TITLE_TEXT: 'Banco Mais',
};
